import Avatar from '@mui/material/Avatar';
import classNames from 'clsx';
import React from 'react';

import flags from '@swf/core/assets/flags';

import styles from './CurrencyIcon.scss';

export interface Props {
  currency: string;
  variant?: 'dropdown' | 'large';
}

const CurrencyIcon: React.FC<Props> = ({ currency, variant }) => {
  const currencyCode = currency.substring(0, 2);

  return (
    <Avatar
      classes={{ root: classNames(styles[variant as keyof typeof styles], styles.icon) }}
      src={flags[currencyCode]}
      data-testid={`flag-${currencyCode}`}
    />
  );
};

export default CurrencyIcon;
